import { render } from "./SecretProrderPage.vue?vue&type=template&id=d110b2fc"
import script from "./SecretProrderPage.vue?vue&type=script&lang=js"
export * from "./SecretProrderPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__